import styled from 'styled-components';
import { Pagination } from 'antd';

export const Container = styled(Pagination)`
  position: relative;
  display: flex;
  float: none;
  justify-content: flex-end;

  .ant-pagination-total-text {
    position: absolute;
    left: 0;
    font-weight: bold;
  }
`;
